import React from 'react';
import crownIcon from '../assets/icons/crown.png';

interface CrownIconProps {
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

const CrownIcon: React.FC<CrownIconProps> = ({ size = 20, style, className }) => {
  return (
    <img
      src={crownIcon}
      alt="Crown"
      width={size}
      height={size}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: '4px',
        ...style,
      }}
      className={className}
    />
  );
};

export default CrownIcon;




























